import Page from './page';
import Post from './post';

export default {
	page: Page,
	post: Post
};



// WEBPACK FOOTER //
// ./src/components/components.js